"use client";

import { useServer } from "@/components/providers/ServerProvider";

export default function ServerControls() {
  const {
    state,
    start,
    stop,
    restart,
    actionLoading,
  } = useServer();

  const isOffline =
    state === "offline" ||
    state === "error";

  const isRunning =
    state === "online";

  const canStop =
    state === "online" ||
    state === "starting";

  return (
    <div className="mt-4 sm:mt-6 rounded-2xl border border-white/10 bg-[#181b1f] p-4 sm:p-6">

      <h2 className="text-lg font-medium">
        Server Controls
      </h2>

      <div className="grid grid-cols-2 sm:flex gap-2 sm:gap-3 mt-4 sm:mt-5">

        <button
          onClick={start}
          disabled={
            !isOffline ||
            actionLoading
          }
          className="px-4 sm:px-6 py-3 rounded-xl bg-green-600 hover:bg-green-500 transition disabled:opacity-40 disabled:cursor-not-allowed"
        >
          Start
        </button>

        <button
          onClick={stop}
          disabled={
            !canStop ||
            actionLoading
          }
          className="px-4 sm:px-6 py-3 rounded-xl bg-red-600 hover:bg-red-500 transition disabled:opacity-40 disabled:cursor-not-allowed"
        >
          Stop
        </button>

        <button
          onClick={restart}
          disabled={
            !isRunning ||
            actionLoading
          }
          className="px-4 sm:px-6 py-3 rounded-xl bg-yellow-600 hover:bg-yellow-500 transition disabled:opacity-40 disabled:cursor-not-allowed"
        >
          Restart
        </button>

        <button className="px-4 sm:px-5 py-3 rounded-xl bg-[#292e35] hover:bg-[#333941] transition">
          ⚙ Settings
        </button>

      </div>

      {actionLoading && (
        <p className="text-sm text-gray-400 mt-4">
          Processing server command...
        </p>
      )}

    </div>
  );
}